import groupBy from 'lodash/groupBy';
import simplur from 'simplur';

export default <T extends { duration: number }>(trips: T[]): Map<string, T[]> =>
    new Map(
        Object.entries(groupBy(trips, ({ duration }) => simplur`${duration} nacht[|en]`)).sort(
            ([, [prev]], [, [next]]) => prev.duration - next.duration
        )
    );
